import getPublicUrl from '@/helpers/utils/routing/getPublicUrl'
import { PageProps } from '@/types'
import { toPathFactory } from '@/helpers/utils/routing/toPathFactories'
const pageUrl = '/[locale]/403'
export const getPageUrl = toPathFactory(pageUrl, getPublicUrl)
export type ForbiddenPageProps = PageProps<typeof pageUrl>
